<script setup>
import {
  PencilIcon,
  TrashIcon,
} from "@heroicons/vue/24/solid";
import {Link, router} from "@inertiajs/vue3";
import {ref} from "vue";
import {useI18n} from "vue-i18n";
import Modal from "../../../../../js/components/Modal.vue";

const {t} = useI18n();

const props = defineProps({
  row: {
    type: Object,
    required: true,
  },
});

const deleteUserModalIsOpen = ref(false);

function setDeleteUserModalIsOpen(value) {
  deleteUserModalIsOpen.value = value;
}

function deleteUser() {
  router.delete(
      route("front.user.delete", {id: props.row.original.id}),
      {
        preserveState: false,
      }
  );
}
</script>

<template>
  <div class="flex h-full items-center justify-center px-4 py-4">
    <button
        class="mx-1 rounded border border-red-600 bg-red-500 p-1 text-white duration-150 hover:bg-red-400 disabled:opacity-40 disabled:hover:bg-red-500"
        @click="setDeleteUserModalIsOpen(true)"
    >
      <TrashIcon class="h-5 w-5"/>
    </button>

    <Modal
        :is-open="deleteUserModalIsOpen"
        :set-is-open="setDeleteUserModalIsOpen"
        size="small"
    >
      <template #title>
        {{
        t("all.title.deleteUser", {
        id: props.row.original.id,
        })
        }}
      </template>

      <template #content>
        {{ t("all.text.areYouSureToDeleteThisUser") }}
      </template>

      <template #footer>
        <div class="flex justify-end">
          <button
              class="mr-2 rounded border border-red-600 bg-red-500 px-4 py-2 text-white duration-150 hover:bg-red-400"
              @click="deleteUser"
          >
            {{ t("all.button.delete") }}
          </button>

          <button
              class="rounded border border-gray-600 bg-gray-500 px-4 py-2 text-white duration-150 hover:bg-gray-400"
              @click="setDeleteUserModalIsOpen(false)"
          >
            {{ t("all.button.cancel") }}
          </button>
        </div>
      </template>
    </Modal>

    <Link
        :href="route('front.user.update', {id: props.row.original.id})"
        class="mx-1 rounded border border-blue-600 bg-blue-500 p-1 text-white duration-150 hover:bg-blue-400"
    >
      <PencilIcon class="h-5 w-5"/>
    </Link>
  </div>
</template>